import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { AppState } from '../../../../reducers'
import { Filters, FiltersBar } from '../../../Utils/Filters/Filter'
import { FilterFromDate, FilterToDate, FilterNumber, FilterClientName, FilterStatusPreorder, FilterVendorName, FilterPreorderOwners } from '../../../Utils/Filters'
import { useTranslation } from 'react-i18next'
import { PERSON } from '../../../../models/User'
import { roleToURLPrefix } from '../../../../App'
import { SessionState, isAdmin, isHeadSales, isManager, isStaff } from '../../../../reducers/auth/session'
import { Stack } from '@mui/material'
import AdminPreorders from '../../AdminPreorders'
import { PreorderListState } from '../../../../reducers/preorder/preorderList'
import Preorder from '../../../../models/Preorder'
import { fetchPreorders } from '../../../../actions/preorder/preorderList'
import moment from 'moment'

interface Props {
  preorderList: PreorderListState
  session: SessionState
}

const AdminPreordersList: React.FC<Props> = ({ preorderList, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['preorder','client','vendor'])

  useEffect(() => {
    dispatch(fetchPreorders(history.location.search))
  }, [dispatch, history.location.search])

  const linkToPreorderDetail = (preorder: Preorder) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/preorders/detail/${preorder.id}`
    history.push(detailUrl)
  }


  const initDefaultFilters: Filters = {
    from: moment('2025-06-09').format(),
    to: moment('2099-12-31').format(),
    statusPO: session.isChaco ? 'P,H,D' : 'P,H,D',
    owner: isAdmin(session) || isManager(session) || session.isChaco ? 'all' : 'me'
    //statusPO : preorderNotClosingStatus.join(',')
    //codigo_cliente: isVendor(session) ? LocalStorage.getClientId(): '' 
  }

  return (
    <Stack style={{ height: 'calc(100% - var(--header-height)'}}>
        <FiltersBar defaultFilters={initDefaultFilters}>
          <FilterFromDate label={t("fromDate")} />
          <FilterToDate label={t("toDate")} />
          <FilterStatusPreorder multiple label={t("status")} />
          <FilterPreorderOwners label={t("owners")} />
          <FilterNumber name="preorderNumber" label={t("number")} />
          {(isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)) ? <FilterClientName name="codigo_cliente" label={t('title', { ns: 'client' })} /> : <></>}
          {(isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)) ? <FilterVendorName name="codigo_vendedor" label={t('title', { ns: 'vendor' })} /> : <></>}
        </FiltersBar>
        <AdminPreorders
          rows={(preorderList.preorders || []).filter((po) => !session.isChaco ? po.warehouse !== 3 : true).map(s => ({ data: s }))}
          loading={preorderList.isFetching!}
          pagination={preorderList.pagination || undefined}
          onClickInfo={linkToPreorderDetail}
        />
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  preorderList: state.preorderList,
  session: state.session
})

export default connect(mapStateToProps, null)(AdminPreordersList)